import React, { FC } from 'react';
import classNames from 'classnames';
import { HorizontalDivider } from '@app/react/uikit/HorizontalDivider';

export interface ToggleButtonAreaProps {
    className?: string;
    children: React.ReactNode;
}

export const ToggleButtonArea: FC<ToggleButtonAreaProps> = ({
    className,
    children,
}) => (
    <div className={classNames('toggle-button-area', className)}>
        {React.Children
              .toArray(children)
              .filter((child) => React.isValidElement(child)).length === 1
        ? children
        : React.Children.map(children, (child, index) => {
            const divider = index % 2 === 0 ? (
                <HorizontalDivider className="toggle-button-area--divider" />
            ) : null;
            return (
                <>
                    {child}
                    {divider}
                </>
            );
        })}
    </div>
);
